
import datetimeProvider from "../../providers/datetime.provider";

import Tooltip from "../shared/Tooltip";
import { Check, Clock } from "react-feather";

export default function RequestServiceInformationHearingDateInfo({
    dateTimeInfo,
    isCheckin
}) {

    const datetime = datetimeProvider.formatDateTimeInTimezone(dateTimeInfo, 'America/Sao_Paulo');

    const type = isCheckin === 'presence' ? 'presence' : isCheckin ? 'checkin' : 'hearing';

    const config = {
        hearing: {
            icon: <Clock className="!w-4 !h-4" />,
            label: 'Data e Hora da Audiência',
            tooltip: 'Data e Hora da Audiência',
            showCountdown: true,
            colorClass: 'text-gray-500',
            valueColorClass: 'text-gray-800',
        },
        presence: {
            icon: <Check className="!w-4 !h-4" />,
            label: 'Presença confirmada em',
            tooltip: 'O faciliter confirmou que estará disponível para realizar a audiência',
            showCountdown: false,
            colorClass: 'text-green-600',
            valueColorClass: 'text-green-700',
        },
        checkin: {
            icon: <Check className="!w-4 !h-4" />,
            label: 'Checkpoint realizado em',
            tooltip: 'O faciliter realizou o checkpoint para a audiência nesse horário',
            showCountdown: false,
            colorClass: 'text-green-600',
            valueColorClass: 'text-green-700',
        },
    };

    const { icon, label, tooltip, showCountdown, colorClass, valueColorClass } = config[type];

    return (
        <div className="flex flex-wrap gap-x-2 gap-y-0.5 items-baseline">
            <Tooltip title={tooltip}>
                <div className={`text-sm flex gap-1.5 items-center whitespace-nowrap ${colorClass}`}>
                    {icon}
                    {label}
                </div>
            </Tooltip>

            <span className={`text-sm font-medium whitespace-nowrap ${valueColorClass}`}>
                {datetimeProvider.formatDateTime(datetime, 'DD/MM [às] HH:mm', true)}
            </span>

            {showCountdown && (
                <span className="text-xs text-gray-400 whitespace-nowrap">
                    ({datetimeProvider.getTimeDifferenceUntilDate(datetimeProvider.getDate(), datetime, 'Audiência já realizada.')})
                </span>
            )}
        </div>
    )
}
